<template>
  <component
    :is="iconComponent"
    :alt="type"
    :class="classes"
    role="img"
    :style="innerStyle"/>
</template>
<script>
const iconClass = 's-svg-icon'

const icons = {}

const requireComponents = require.context('../icons/compress/', false, /.svg$/)

requireComponents.keys().forEach(fileName => {
  const iconName = fileName.replace(/^\.\/(.+)\.svg$/, '$1')
  const componentConfig = requireComponents(fileName)
  icons[iconName] = componentConfig.default || componentConfig
})
/**
 * Инлайн иконки svg
 * @displayName Icon
 */
export default {
  name: 'sIcon',
  componentName: 'sIcon',
  computed: {
    iconComponent() {
      return icons[this.type]
    },
    innerStyle() {
      const style = {
        '--color': this.color ? this.color : 'currentColor',
      }
      let width = this.size ? `${this.size}px` : '14px'
      let lineHeight = '14px;'
      if (this.lineHeight && typeof this.lineHeight === 'string' && this.lineHeight.includes('px')) {
        lineHeight = this.lineHeight
      } else {
        lineHeight = width = `${this.size * this.lineHeight}px`
      }
      style.height = lineHeight
      style['min-width'] = width
      style['max-width'] = width
      return style
    },
    classes() {
      return [
        `${iconClass}`,
        {
          [`${iconClass}-spin`]: this.spin,
          [`${iconClass}-pulse`]: this.pulse,
          [`${iconClass}-rotate-${this.rotate}`]: this.rotate !== '' && this.rotate !== '0',
          [`${iconClass}-flip-${this.flip}`]: this.flip !== '',
        },
      ]
    },
  },
  props: {
    /**
     * Тип иконки (имя файла из папки /icons/compress/)
     */
    type: {
      type: String,
      required: true,
      validator(value) {
        const correct = Object.prototype.hasOwnProperty.call(icons, value)
        return correct
      }
    },
    /**
    *  Размер иконки в px
    */
    size: {
      type: [Number, String],
      default: 16,
    },
    /**
     * Цвет иконки
     */
    color: {
      type: String,
      default: 'currentColor',
    },
    /**
     * Плавное вращение иконки
     */
    spin: {
      type: Boolean,
      default: false,
    },
    /**
     * Ступеньчатое вращение
     */
    pulse: {
      type: Boolean,
      default: false,
    },
    /**
     * Поворот иконки. Отрицательные для нужной анимации
     */
    rotate: {
      type: [Number, String],
      validator(value) {
        return ['', '0', '45', '90', '135', '180', '225', '270', '315', '-45', '-90', '-135', '-180', '-225', '-270', '-315',
          0, 45, 90, 135, 180, 225, 270, 315, -45, -90, -135, -180, -225, -270, -315
        ].includes(value)
      },
      default: '',
    },
    /**
     * Отражение иконки
     */
    flip: {
      type: String,
      validator(value) {
        return ['', 'horizontal', 'vertical'].includes(value)
      },
      default: '',
    },
    /**
     * line-height символа иконки
     */
    lineHeight: {
      type: [String, Number],
      default: 1,
    },
  },
}
</script>
